import { render, staticRenderFns } from "./ThreeRow.vue?vue&type=template&id=af06f6d6"
import script from "./ThreeRow.vue?vue&type=script&lang=js"
export * from "./ThreeRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports